import React, { useState, useRef, useEffect } from "react";
import LineIcon from "../../assets/line.svg";
import SpeakerIcon from "../../assets/icons/speaker.svg";
import AwardIcon from "../../assets/icons/award.svg";
import RecentIcon from "../../assets/icons/recent.svg";
import CupIcon from "../../assets/icons/cup-2.svg";
import RocketIcon from "../../assets/icons/rocket.svg";
import PersonIcon from "../../assets/icons/person.svg";
import ArrowDownIcon from "../../assets/icons/arrow-down.svg";
import ArrowExpandIcon from "../../assets/icons/arrow-expand.svg";
import SuiLogoIcon from "../../assets/icons/sui-sui-logo.svg";
import CoinflipGame from "../../Components/Games/Coinflip/CoinflipGame";
import HowToPlayModal from "../../Components/Games/Coinflip/HowToPlayModal";
// import backgroundMusic from "../../assets/sounds/coinflip-background.mp3";

interface LeaderboardEntry {
  id: number;
  user: string;
  amountBet: number;
  multiplier: number;
  amountWon: number;
  played: string;
  avatar?: string;
}

type LeaderboardTab = "recent" | "winners" | "panther" | "mystakes";

function Coinflip() {
  const [isHowToPlayOpen, setIsHowToPlayOpen] = useState(false);
  const [activeTab, setActiveTab] = useState<LeaderboardTab>("recent");
  const [pageSize, setPageSize] = useState(10);
  const [isGameFlipping, setIsGameFlipping] = useState(false);
  const [isShowingResults, setIsShowingResults] = useState(false);
  const shouldHideLeaderboard = isGameFlipping || isShowingResults;
  const [isPageSizeOpen, setIsPageSizeOpen] = useState(false);
  const [isSoundPlaying, setIsSoundPlaying] = useState(false);
  const [isPlayDetailsOpen, setIsPlayDetailsOpen] = useState(false);
  const [selectedEntry, setSelectedEntry] = useState<LeaderboardEntry | null>(
    null
  );

  const audioRef = useRef<HTMLAudioElement | null>(null);

  // Initialize audio
  // useEffect(() => {
  //   audioRef.current = new Audio(backgroundMusic);
  //   audioRef.current.loop = true;
  //   audioRef.current.volume = 0.3; // Set volume to 30%

  //   return () => {
  //     if (audioRef.current) {
  //       audioRef.current.pause();
  //       audioRef.current = null;
  //     }
  //   };
  // }, []);

  const toggleSound = async () => {
    if (!audioRef.current) return;

    try {
      if (isSoundPlaying) {
        audioRef.current.pause();
        setIsSoundPlaying(false);
      } else {
        await audioRef.current.play();
        setIsSoundPlaying(true);
      }
    } catch (error) {
      console.error("Error playing audio:", error);
    }
  };

  const handleRowClick = (entry: LeaderboardEntry) => {
    setSelectedEntry(entry);
    setIsPlayDetailsOpen(true);
  };

  const closePlayDetails = () => {
    setIsPlayDetailsOpen(false);
    setSelectedEntry(null);
  };

  // Sample leaderboard data
  const leaderboardData: Record<LeaderboardTab, LeaderboardEntry[]> = {
    recent: [
      {
        id: 1,
        user: "0x...DE672",
        amountBet: 150.5,
        multiplier: 1.2,
        amountWon: 180.6,
        played: "2 mins ago",
      },
      {
        id: 2,
        user: "0x...DE672",
        amountBet: 89.3,
        multiplier: 1.2,
        amountWon: 0,
        played: "5 mins ago",
      },
      {
        id: 3,
        user: "0x...DE672",
        amountBet: 200.0,
        multiplier: 1.2,
        amountWon: 240.0,
        played: "8 mins ago",
      },
      {
        id: 4,
        user: "0x...DE672",
        amountBet: 75.25,
        multiplier: 1.2,
        amountWon: 90.3,
        played: "12 mins ago",
      },
      {
        id: 5,
        user: "0x...DE672",
        amountBet: 500.0,
        multiplier: 1.2,
        amountWon: 0,
        played: "15 mins ago",
      },
      {
        id: 6,
        user: "0x...DE672",
        amountBet: 500.0,
        multiplier: 1.2,
        amountWon: 0,
        played: "15 mins ago",
      },
      {
        id: 7,
        user: "0x...DE672",
        amountBet: 500.0,
        multiplier: 1.2,
        amountWon: 0,
        played: "15 mins ago",
      },
      {
        id: 8,
        user: "0x...DE672",
        amountBet: 500.0,
        multiplier: 1.2,
        amountWon: 0,
        played: "15 mins ago",
      },
      {
        id: 9,
        user: "0x...DE672",
        amountBet: 500.0,
        multiplier: 1.2,
        amountWon: 0,
        played: "15 mins ago",
      },
      {
        id: 10,
        user: "0x...DE672",
        amountBet: 500.0,
        multiplier: 1.2,
        amountWon: 0,
        played: "15 mins ago",
      },
    ],
    winners: [
      {
        id: 1,
        user: "0x...DE672",
        amountBet: 1000.0,
        multiplier: 50.0,
        amountWon: 50000.0,
        played: "1 hour ago",
      },
      {
        id: 2,
        user: "0x...DE672",
        amountBet: 250.0,
        multiplier: 1.2,
        amountWon: 300.0,
        played: "2 hours ago",
      },
      {
        id: 3,
        user: "0x...DE672",
        amountBet: 180.5,
        multiplier: 1.2,
        amountWon: 216.6,
        played: "3 hours ago",
      },
    ],
    panther: [
      {
        id: 1,
        user: "0x...DE672",
        amountBet: 100.0,
        multiplier: 50.0,
        amountWon: 5000.0,
        played: "30 mins ago",
      },
      {
        id: 2,
        user: "0x...DE672",
        amountBet: 50.0,
        multiplier: 50.0,
        amountWon: 0,
        played: "1 hour ago",
      },
    ],
    mystakes: [
      {
        id: 1,
        user: "You",
        amountBet: 25.0,
        multiplier: 1.2,
        amountWon: 30.0,
        played: "10 mins ago",
      },
      {
        id: 2,
        user: "You",
        amountBet: 50.0,
        multiplier: 1.2,
        amountWon: 0,
        played: "25 mins ago",
      },
    ],
  };

  const tabs = [
    {
      key: "recent" as LeaderboardTab,
      label: "Recent Stakes",
      icon: RecentIcon,
    },
    { key: "winners" as LeaderboardTab, label: "Top Winners", icon: CupIcon },
    {
      key: "panther" as LeaderboardTab,
      label: "Panther Bet",
      icon: RocketIcon,
    },
    { key: "mystakes" as LeaderboardTab, label: "My Stakes", icon: PersonIcon },
  ];

  const pageSizeOptions = [5, 10, 20, 50];

  const currentData = leaderboardData[activeTab].slice(0, pageSize);

  return (
    <div className="coinflip">
      <div className="coinflip__header">
        <div className="coinflip__top-row">
          <h1 className="coinflip__title">COINFLIP</h1>
          <div className="coinflip__buttons">
            <button
              className={`coinflip__sound-btn ${
                isSoundPlaying ? "active" : ""
              }`}
              onClick={toggleSound}
            >
              <img
                src={SpeakerIcon}
                alt="Sound"
                className="coinflip__sound-icon"
              />
            </button>
            <button
              className="coinflip__help-btn"
              onClick={() => setIsHowToPlayOpen(true)}
            >
              How to Play
            </button>
          </div>
        </div>
        <img src={LineIcon} alt="Line" className="coinflip__line" />
        <CoinflipGame
          onFlippingStateChange={setIsGameFlipping}
          onResultsStateChange={setIsShowingResults}
        />
      </div>

      {/* Leaderboards Section */}
      {!shouldHideLeaderboard && (
        <div className="coinflip__leaderboards">
          <div className="coinflip__leaderboards-header">
            <div className="coinflip__leaderboards-title-row">
              <img
                src={AwardIcon}
                alt="Award"
                className="coinflip__leaderboards-icon"
              />
              <h2 className="coinflip__leaderboards-title">LEADERBOARDS</h2>
            </div>
            <img src={LineIcon} alt="Line" className="coinflip__line" />
          </div>

          {/* Tabs */}
          <div className="coinflip__leaderboards-controls">
            <div className="coinflip__tabs-container">
              <div className="coinflip__tabs">
                {tabs.map((tab) => (
                  <button
                    key={tab.key}
                    className={`coinflip__tab ${
                      activeTab === tab.key ? "active" : ""
                    }`}
                    onClick={() => setActiveTab(tab.key)}
                  >
                    <img
                      src={tab.icon}
                      alt={tab.label}
                      className="coinflip__tab-icon"
                    />
                    {tab.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Page Size Selector - Hidden on mobile */}
            <div className="coinflip__page-size coinflip__page-size--desktop">
              <div
                className="coinflip__page-size-selector"
                onClick={() => setIsPageSizeOpen(!isPageSizeOpen)}
              >
                <span>{pageSize}</span>
                <img
                  src={ArrowDownIcon}
                  alt="Arrow Down"
                  className={`coinflip__page-size-arrow ${
                    isPageSizeOpen ? "open" : ""
                  }`}
                />
              </div>
              {isPageSizeOpen && (
                <div className="coinflip__page-size-dropdown">
                  {pageSizeOptions.map((size) => (
                    <button
                      key={size}
                      className="coinflip__page-size-option"
                      onClick={() => {
                        setPageSize(size);
                        setIsPageSizeOpen(false);
                      }}
                    >
                      {size}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Table */}
          <div className="coinflip__leaderboards-table">
            {/* Desktop Table Header */}
            <div className="coinflip__table-header coinflip__table-header--desktop">
              <div className="coinflip__table-header-cell">User</div>
              <div className="coinflip__table-header-cell">Amount Bet</div>
              <div className="coinflip__table-header-cell">Multiplier</div>
              <div className="coinflip__table-header-cell">Amount Won</div>
              <div className="coinflip__table-header-cell">Played</div>
            </div>

            {/* Mobile Table Header */}
            <div className="coinflip__table-header coinflip__table-header--mobile">
              <div className="coinflip__table-header-cell">User</div>
              <div className="coinflip__table-header-cell">Amount Won</div>
              <div className="coinflip__table-header-cell"></div>
            </div>

            {/* Table Body */}
            <div className="coinflip__table-body">
              {currentData.map((entry, index) => (
                <div
                  key={entry.id}
                  className={`coinflip__table-row ${
                    index % 2 === 0 ? "coinflip__table-row--highlighted" : ""
                  }`}
                >
                  {/* Desktop Row */}
                  <div className="coinflip__table-row--desktop">
                    <div className="coinflip__table-cell coinflip__table-cell--user">
                      {entry.avatar && (
                        <img
                          src={entry.avatar}
                          alt={entry.user}
                          className="coinflip__user-avatar"
                        />
                      )}
                      <span className="coinflip__username">{entry.user}</span>
                    </div>
                    <div className="coinflip__table-cell">
                      <span className="coinflip__amount">
                        {entry.amountBet.toFixed(2)}
                      </span>
                      <img
                        src={SuiLogoIcon}
                        alt="SUI"
                        className="coinflip__sui-logo"
                      />
                    </div>
                    <div className="coinflip__table-cell">
                      <span className="coinflip__multiplier">
                        {entry.multiplier}x
                      </span>
                    </div>
                    <div className="coinflip__table-cell">
                      <span
                        className={`coinflip__amount ${
                          entry.amountWon > 0
                            ? "coinflip__amount--win"
                            : "coinflip__amount--loss"
                        }`}
                      >
                        {entry.amountWon.toFixed(2)}
                      </span>
                      <img
                        src={SuiLogoIcon}
                        alt="SUI"
                        className="coinflip__sui-logo"
                      />
                    </div>
                    <div className="coinflip__table-cell">
                      <span className="coinflip__played">{entry.played}</span>
                    </div>
                  </div>

                  {/* Mobile Row */}
                  <div
                    className="coinflip__table-row--mobile"
                    onClick={() => handleRowClick(entry)}
                  >
                    <div className="coinflip__table-cell coinflip__table-cell--user">
                      {entry.avatar && (
                        <img
                          src={entry.avatar}
                          alt={entry.user}
                          className="coinflip__user-avatar"
                        />
                      )}
                      <span className="coinflip__username">{entry.user}</span>
                    </div>
                    <div className="coinflip__table-cell">
                      <span
                        className={`coinflip__amount ${
                          entry.amountWon > 0
                            ? "coinflip__amount--win"
                            : "coinflip__amount--loss"
                        }`}
                      >
                        {entry.amountWon.toFixed(2)}
                      </span>
                      <img
                        src={SuiLogoIcon}
                        alt="SUI"
                        className="coinflip__sui-logo"
                      />
                    </div>
                    <div className="coinflip__table-cell coinflip__table-cell--expand">
                      <img
                        src={ArrowExpandIcon}
                        alt="Expand"
                        className="coinflip__expand-icon"
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Play Details Modal */}
      {isPlayDetailsOpen && selectedEntry && (
        <div className="play-details__modal-overlay" onClick={closePlayDetails}>
          <div
            className="play-details__modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="play-details__modal-header">
              <h3 className="play-details__modal-title">Play Details</h3>
              <button
                className="play-details__modal-close"
                onClick={closePlayDetails}
              >
                <img
                  src={ArrowExpandIcon}
                  alt="Close"
                  className="play-details__close-icon"
                />
              </button>
            </div>

            <div className="play-details__content">
              <div className="play-details__row">
                <span className="play-details__label">User</span>
                <span className="play-details__value">
                  {selectedEntry.user}
                </span>
              </div>
              <div className="play-details__row">
                <span className="play-details__label">Amount Bet</span>
                <div className="play-details__value-with-icon">
                  <span className="play-details__value">
                    {selectedEntry.amountBet.toFixed(2)}
                  </span>
                  <img
                    src={SuiLogoIcon}
                    alt="SUI"
                    className="play-details__sui-logo"
                  />
                </div>
              </div>
              <div className="play-details__row">
                <span className="play-details__label">Multiplier</span>
                <span className="play-details__value">
                  {selectedEntry.multiplier}x
                </span>
              </div>
              <div className="play-details__row">
                <span className="play-details__label">Amount Won</span>
                <div className="play-details__value-with-icon">
                  <span
                    className={`play-details__value ${
                      selectedEntry.amountWon > 0
                        ? "play-details__value--win"
                        : "play-details__value--loss"
                    }`}
                  >
                    {selectedEntry.amountWon.toFixed(2)}
                  </span>
                  <img
                    src={SuiLogoIcon}
                    alt="SUI"
                    className="play-details__sui-logo"
                  />
                </div>
              </div>
              <div className="play-details__row">
                <span className="play-details__label">Date</span>
                <span className="play-details__value">
                  {selectedEntry.played}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}

      <HowToPlayModal
        isOpen={isHowToPlayOpen}
        onClose={() => setIsHowToPlayOpen(false)}
      />
    </div>
  );
}

export default Coinflip;
